var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_91_1923)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M6.78613 17.5H0.536133V0H7.69522L10.5361 1.35031L13.377 0H20.5361V17.5H14.2861V18.75H11.7861H11.3316H9.74068H9.28613H6.78613V17.5ZM11.2861 16.8432V2.5242L13.9409 1.5H19.0361V11H14.0361V16.3143L11.2861 16.8432ZM7.13132 1.5L9.78613 2.5242V16.8432L7.29322 16H2.03613V1.5H7.13132ZM15.5361 16V12.5H19.0361L15.5361 16Z"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_91_1923" } }, [
          _c("rect", {
            attrs: {
              width: "20",
              height: "20",
              fill: "white",
              transform: "translate(0.536133)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }